'use memo';

import { Outlet, createFileRoute, useParams } from '@tanstack/react-router';
import { FillScreen } from '@/components/Layout';
import { ViewportLoader } from '@/components/Loading';
import { Text } from '@/components/Typography/Text';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { salaryAndWagesKeyPrefix } from '@/routes/_staff/salary-and-wages/-utils/i18n';
import { EmployeePaySlipHeader } from './-components/EmployeePaySlipHeader';
import { useEmployeePaySlips } from './-query';
export const Route = createFileRoute('/_staff/salary-and-wages/_layout/reports/$employeeId')({
  component: EmployeePaySlipDetailShell
});
function EmployeePaySlipDetailShell() {
  const {
    employeeId
  } = useParams({
    from: '/_staff/salary-and-wages/_layout/reports/$employeeId'
  });
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: salaryAndWagesKeyPrefix
  });
  const {
    data,
    isPending,
    isError
  } = useEmployeePaySlips(employeeId);
  if (isPending) {
    return <ViewportLoader />;
  }
  if (isError || !data) {
    return <FillScreen className="grid place-items-center">
        <Text variant="p" className="text-neutral-muted-on-fill">
          {t($ => $.employeeDetail.empty)}
        </Text>
      </FillScreen>;
  }
  return <div className="flex h-full min-h-0 min-w-0 flex-1 flex-col">
      <EmployeePaySlipHeader profile={data.profile} />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <Outlet />
      </div>
    </div>;
}